import { render } from "./PhotoView.vue?vue&type=template&id=4a0c14a4&scoped=true"
import script from "./PhotoView.vue?vue&type=script&lang=js"
export * from "./PhotoView.vue?vue&type=script&lang=js"

import "./PhotoView.vue?vue&type=style&index=0&id=4a0c14a4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0c14a4"]])

export default __exports__